


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class InputSpinner extends Vue {
  @Prop({ default: "" }) private label!: string;
  @Prop({ default: 0 }) private min!: number;
  @Prop({ default: false }) private readonly!: boolean;
  @Prop({ default: 9999 }) private max!: number;
  @Prop({ default: 4 }) private maxLength!: number;
  @Prop({ default: true }) private outline!: boolean;
  @Prop({ default: [] }) private rules!: any[];
  @Prop({ default: 1 }) private step!: number;
  @Prop({ default: null }) private value!: any;
  @Prop({ default: '' }) private suffix!: string;

  get mask() {
    let mask = "";
    for (let i = 0; i < this.maxLength; i++) mask = `${mask}#`;
    return mask;
  }

  mounted() {}

  increase() {
    if (isNaN(parseInt(this.value))) return this.$emit("input", this.step);
    if (this.value === this.max) return;
    this.$emit("input", parseInt(this.value) + this.step);
  }

  decrease() {
    if (isNaN(parseInt(this.value))) return this.$emit("input", this.min);
    if (this.value < 1) return;
    if (this.value === this.min) return;
    this.$emit("input", parseInt(this.value) - this.step);
  }
}
